import {inject, Injectable} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {DialogFooterComponent} from '../../../../shared/components/dialog-footer/dialog-footer';
import {UserDetails} from './user-details';
import {User} from '../../../../core/auth/models/user.models';

@Injectable({
	providedIn: 'root'
})
export class UserDetailsService {
	private dialogService: DialogService = inject(DialogService)

	openDetailDialog(user: User) {
		const dialogRef = this.dialogService.open(UserDetails, {
			header: 'Dettaglio Ticket',
			data: { userId: user.id },
			width: '40vw',
			closable: true,
			modal: true,
			baseZIndex: 10000,
			templates: {
				footer: DialogFooterComponent
			}
		});

		return dialogRef?.onClose
	}
}
